// extracted by mini-css-extract-plugin
export default {"container":"Products_container__uMIWj","products":"Products_products__V7KIl","menu":"Products_menu__koiGV","list":"Products_list__KPPDh","product":"Products_product__rPWhu"};